
export class LabelHoverPlugin {
    afterEvent(chartInstance, chartEvent) {
        const canvas = chartInstance.canvas;
        if (this.isHoverOnLabel(chartInstance, chartEvent.event)) {
            canvas.style.cursor = "pointer";
        }
    }

    private readonly isHoverOnLabel = (chartInstance, chartEvent) => {
        /**
         *  Ger träff på hela ytan XXXXXX för alla rader.
         *  Ignorerar dvs själva texten och ger "true" för allt inom ytan.
         *
         *   ------
         *   XXXXX- ==========
         *   XXXXX- ============
         *   XXXXX- ===============
         *   XXXXX- ==============
         *   ------
         */
        // eslint-disable-next-line sonarjs/prefer-single-boolean-return
        if (chartEvent.y <= chartInstance.scales.y.top ||
            chartEvent.y >= chartInstance.scales.y.bottom ||
            chartEvent.x >= chartInstance.scales.y.right) {
            return false;
        }
        return true;
    };
}
